import React, { Fragment, HTMLProps } from 'react';
import { Transition } from '@headlessui/react';

const ModalScreenBase: React.FC<{isShown: boolean, classNameInner?: string, classNameOpacity?: string} & HTMLProps<HTMLDivElement>> 
= ({ isShown, className, classNameInner, classNameOpacity, children }) => {
    return (
        <Transition.Root show={isShown} as={Fragment}>
            <div className={`fixed inset-0 text-base z-1000 ${className}`}>
                <div className={`items-center justify-center min-h-screen ${classNameInner}`}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className={`fixed inset-0 bg-black transition-opacity ${classNameOpacity ?? 'bg-opacity-80'}`} />
                    </Transition.Child>
                    <Transition.Child
                        as="div"
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        className="w-full transform p-0 md:p-10"
                    >
                        {children}
                    </Transition.Child>
                </div>
            </div>
        </Transition.Root>
    );
}

export const ModalScreenFunds: React.FC<{isShown: boolean} & HTMLProps<HTMLDivElement>> 
= ({ isShown, className, children }) => {
    return (
        <ModalScreenBase
            isShown={isShown}
            className={`${className} overflow-y-auto overscroll-contain`}
            classNameInner="flex w-screen"
            classNameOpacity="bg-opacity-80"
            children={children} 
        />
    )
}

export const ModalScreenInvestment: React.FC<{isShown: boolean} & HTMLProps<HTMLDivElement>>
= ({ isShown, className, children }) => {
    return (
        <ModalScreenBase 
            isShown={isShown}
            className={`${className} overflow-y-auto overscroll-contain`}
            children={children} 
        />
    )
}

export const ModalScreenPension: React.FC<{isShown: boolean} & HTMLProps<HTMLDivElement>>
= ({ isShown, className, children }) => {
    return (
        <ModalScreenBase 
            isShown={isShown}
            className={`${className} w-full lg:w-5/6 xl:w-2/3 md:mx-auto overflow-y-auto overscroll-contain`}
            classNameOpacity='bg-opacity-50'
            children={children} 
        />
    )
}